export const validatePersonalDetails = (formData) => {
    const errors = {};

    if (!formData.gender) {
        errors.gender = "Gender is required";
    }

    if (!formData.dob) {
        errors.dob = "Date Of Birth is required";
    }

    if (!formData.maritalStatus) {
        errors.maritalStatus = "Marital Status is required";
    }

    if (
        formData.cibilScore === null ||
        formData.cibilScore === undefined ||
        String(formData.cibilScore).trim() === ""
    ) {
        errors.cibilScore = "CIBIL Score is required";

    } else if (
        Number(formData.cibilScore) < 300 ||
        Number(formData.cibilScore) > 900
    ) {
        errors.cibilScore =
            "CIBIL Score must be between 300 and 900";
    }

    if (!formData.cibilScoreDate) {
        errors.cibilScoreDate =
            "CIBIL Score Date is required";
    } else {
        const selectedDate = new Date(
            formData.cibilScoreDate
        );

        const today = new Date();

        selectedDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        if (selectedDate > today) {
            errors.cibilScoreDate =
                "Future date is not allowed";
        }
    }
    if (!formData.personWithDisability) {
        errors.personWithDisability =
            "This field is required";
    }

    if (
        formData.personWithDisability === "Yes"
    ) {
        // if (!formData.disabilityPercentage) {
        //     errors.disabilityPercentage =
        //         "Disability Percentage is required";
        // }

        // if (
        //     Number(formData.disabilityPercentage) < 1 ||
        //     Number(formData.disabilityPercentage) > 100
        // ) {
        //     errors.disabilityPercentage =
        //         "Percentage must be between 1 and 100";
        // }

        // if (!formData.natureOfDisability?.trim()) {
        //     errors.natureOfDisability =
        //         "Nature Of Disability is required";
        // }

        if (!formData.disabilityBoardName?.trim()) {
            errors.disabilityBoardName =
                "Board Name is required";
        } else if (
            !/^[A-Za-z\s.,&()-]+$/.test(
                formData.disabilityBoardName
            )
        ) {
            errors.disabilityBoardName =
                "Please enter a valid Board Name";
        }

        if (!formData.disabilityReferenceNumber?.trim()) {
            errors.disabilityReferenceNumber =
                "Reference Number is required";
        } else if (
            !/^[A-Za-z0-9/-]+$/.test(
                formData.disabilityReferenceNumber
            )
        ) {
            errors.disabilityReferenceNumber =
                "Please enter a valid Reference Number";
        }

        if (!formData.disabilityCertificateDate) {
            errors.disabilityCertificateDate =
                "Certificate Date is required";
        } else {
            const selectedDate = new Date(
                formData.disabilityCertificateDate
            );

            const today = new Date();

            selectedDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);

            if (selectedDate > today) {
                errors.disabilityCertificateDate =
                    "Future date is not allowed";
            }
        }
        // if (!formData.disabilityFile) {
        //     errors.disabilityFile =
        //         "Please upload disability certificate";
        // }
    }

    return errors;
};

export const validateAddress = (formData) => {
    const errors = {};

    if (!formData.corrAddressLine1?.trim()) {
        errors.corrAddressLine1 = "Address Line 1 is required";
    }

    if (!formData.corrAddressLine2?.trim()) {
        errors.corrAddressLine2 = "Address Line 2 is required";
    }

    if (!formData.corrAddressLine2?.trim()) {
        errors.corrAddressLine2 = "Address Line 2 is required";
    }

    if (!formData.corrCity?.trim()) {
        errors.corrCity = "City is required";
    }

    if (!formData.corrState?.trim()) {
        errors.corrState = "State is required";
    }

    if (!formData.corrDistrict?.trim()) {
        errors.corrDistrict = "District is required";
    }

    if (!formData.corrPincode?.trim()) {
        errors.corrPincode = "Pincode is required";
    }

    if (
        !formData.addressProofFile &&
        !formData.addressProofFileUrl
    ) {
        errors.addressProofFile = "Address Proof is required";
    }
    if (!formData.stateOfOrigin?.trim()) {
        errors.stateOfOrigin = "State Of Origin is required";
    }

    if (!formData.religion?.trim()) {
        errors.religion = "Religion is required";
    }
    if (!formData.minority) {
        errors.minority = "Please select Minority Status";
    }

    if (!formData.stateOfDomicile?.trim()) {
        errors.stateOfDomicile = "State Of Domicile is required";
    }

    if (!formData.domicileDistrict?.trim()) {
        errors.domicileDistrict = "Domicile District is required";
    }

    if (!formData.domicileCity?.trim()) {
        errors.domicileCity = "City/Town Of Domicile is required";
    }
    if (!formData.casteCategory?.trim()) {
        errors.casteCategory = "Caste Category is required";
    }

    if (!formData.casteCommunity?.trim()) {
        errors.casteCommunity = "Caste Community is required";
    }

    if (!formData.nationality?.trim()) {
        errors.nationality = "Nationality is required";
    }

    if (!formData.bloodGroup?.trim()) {
        errors.bloodGroup = "Blood Group is required";
    } else if (
        !/^(A|B|AB|O)[+-]$/i.test(formData.bloodGroup)
    ) {
        errors.bloodGroup = "Enter valid blood group (A+, B+, AB+, O-, etc.)";
    }

    if (!formData.mobile?.trim()) {
        errors.mobile = "Mobile Number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
        errors.mobile = "Enter a valid 10-digit mobile number";
    }

    if (!formData.email?.trim()) {
        errors.email = "Email Address is required";
    } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
        errors.email = "Enter a valid email address";
    }

    // Voter ID (Optional)
    // if (formData.voterId?.trim()) {
    //     if (
    //         !/^[A-Z]{3}[0-9]{7}$/.test(
    //             formData.voterId.trim()
    //         )
    //     ) {
    //         errors.voterId =
    //             "Voter ID must be 3 letters followed by 7 digits (e.g. ABC1234567)";
    //     }
    // }

    // Driving License (Optional)
    // if (formData.drivingLicenseNo?.trim()) {
    //     if (
    //         !/^[A-Z]{2}[0-9]{2}[0-9]{11}$/.test(
    //             formData.drivingLicenseNo.trim()
    //         )
    //     ) {
    //         errors.drivingLicenseNo =
    //             "Enter a valid Driving License Number";
    //     }
    // }

    // Passport Number (Optional)
    // if (formData.passportNo?.trim()) {
    //     if (
    //         !/^[A-Z][0-9]{7}$/i.test(
    //             formData.passportNo.trim()
    //         )
    //     ) {
    //         errors.passportNo =
    //             "Enter a valid Passport Number";
    //     }
    // }

    // if (!formData.voterId?.trim()) {
    //     errors.voterId =
    //         "Voter ID Card Number is required";
    // } else if (
    //     !/^[A-Z]{3}[0-9]{7}$/.test(
    //         formData.voterId.trim()
    //     )
    // ) {
    //     errors.voterId =
    //         "Voter ID must be 3 letters followed by 7 digits (e.g. ABC1234567)";
    // }

    // if (!formData.drivingLicenseNo?.trim()) {
    //     errors.drivingLicenseNo =
    //         "Driving License Number is required";
    // } else if (
    //     !/^[A-Z]{2}[0-9]{2}[0-9]{11}$/.test(
    //         formData.drivingLicenseNo
    //     )
    // ) {
    //     errors.drivingLicenseNo =
    //         "Enter a valid Driving License Number";
    // }

    // if (!formData.passportNo?.trim()) {
    //     errors.passportNo = "Passport Number is required";
    // } else if (!/^[A-Z][0-9]{7}$/i.test(formData.passportNo)) {
    //     errors.passportNo = "Enter a valid Passport Number";
    // }

    return errors;
};

export const validatePreviousOrganisationDetails = (
    formData
) => {
    const errors = {
        experienceDetails: {},
    };

    formData.experienceDetails?.forEach(
        (exp, index) => {
            const rowErrors = {};

            // PRAN Card Number
            if (!exp.pranCardNumber?.trim()) {
                rowErrors.pranCardNumber =
                    "PRAN Card Number is required";
            } else if (
                !/^\d{12}$/.test(
                    exp.pranCardNumber
                )
            ) {
                rowErrors.pranCardNumber =
                    "PRAN Card Number must be 12 digits";
            }

            // Employee Code
            if (!exp.empCode?.trim()) {
                rowErrors.empCode =
                    "Employee Code is required";
            } else if (
                !/^[A-Za-z0-9-]+$/.test(
                    exp.empCode
                )
            ) {
                rowErrors.empCode =
                    "Employee Code can contain only letters, numbers and hyphen (-)";
            }

            // Organisation Name
            if (
                !exp.organisationName?.trim()
            ) {
                rowErrors.organisationName =
                    "Organisation Name is required";
            }

            // Organisation Address
            if (
                !exp.organisationAddress?.trim()
            ) {
                rowErrors.organisationAddress =
                    "Organisation Address is required";
            } else if (
                exp.organisationAddress.trim()
                    .length < 10
            ) {
                rowErrors.organisationAddress =
                    "Organisation Address must be at least 10 characters";
            }

            // Designation
            if (!exp.designation?.trim()) {
                rowErrors.designation =
                    "Designation is required";
            }

            // Description Of Work
            if (
                !exp.descriptionOfWork?.trim()
            ) {
                rowErrors.descriptionOfWork =
                    "Description Of Work is required";
            }

            // // Last Drawn Salary
            // if (
            //     !exp.lastDrawnSalary &&
            //     exp.lastDrawnSalary !== 0
            // ) {
            //     rowErrors.lastDrawnSalary =
            //         "Last Drawn Salary is required";
            // }

            // From Date
            if (!exp.fromDate) {
                rowErrors.fromDate =
                    "From Date is required";
            }

            // To Date
            // Required only when salary is empty
            if (
                !exp.lastDrawnSalary &&
                !exp.toDate
            ) {
                rowErrors.toDate =
                    "To Date is required";
            }

            // Reason For Leaving
            if (
                !exp.isCurrentlyWorking &&
                !exp.reasonForLeaving?.trim()
            ) {
                rowErrors.reasonForLeaving =
                    "Reason For Leaving is required";
            }

            // Employer Email
            if (
                !exp.employerEmail?.trim()
            ) {
                rowErrors.employerEmail =
                    "Employer Email is required";
            } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                    exp.employerEmail
                )
            ) {
                rowErrors.employerEmail =
                    "Enter a valid Employer Email";
            }

            // Employer Contact
            if (
                !exp.employerContact?.trim()
            ) {
                rowErrors.employerContact =
                    "Employer Contact is required";
            } else if (
                !/^\d{10}$/.test(
                    exp.employerContact
                )
            ) {
                rowErrors.employerContact =
                    "Enter a valid 10-digit mobile number";
            }

            if (
                Object.keys(rowErrors).length > 0
            ) {
                errors.experienceDetails[index] =
                    rowErrors;
            }
        }
    );

    return errors;
};

export const validateAttestationDetails = (
    attestationDetails
) => {
    const errors = {};

    attestationDetails?.forEach(
        (item, index) => {
            const rowErrors = {};

            if (!item.attestationFromDate) {
                rowErrors.attestationFromDate =
                    "From Date is required";
            }

            if (!item.attestationToDate) {
                rowErrors.attestationToDate =
                    "To Date is required";
            }

            if (!item.addressLine1?.trim()) {
                rowErrors.addressLine1 =
                    "Address Line 1 is required";
            }

            if (!item.addressLine2?.trim()) {
                rowErrors.addressLine2 =
                    "Address Line 2 is required";
            }

            // if (!item.addressLine3?.trim()) {
            //     rowErrors.addressLine3 =
            //         "Address Line 3 is required";
            // }

            if (!item.city?.trim()) {
                rowErrors.city = "City is required";
            }

            if (!item.state?.trim()) {
                rowErrors.state = "State is required";
            }

            if (!item.district?.trim()) {
                rowErrors.district =
                    "District is required";
            }

            if (!item.pinCode?.trim()) {
                rowErrors.pinCode =
                    "PIN Code is required";
            } else if (
                !/^\d{6}$/.test(
                    item.pinCode
                )
            ) {
                rowErrors.pinCode =
                    "Enter a valid 6-digit PIN Code";
            }

            if (!item.documentUrl) {
                rowErrors.documentUrl =
                    "Document is required";
            }

            if (
                Object.keys(rowErrors).length > 0
            ) {
                errors[index] = rowErrors;
            }
        }
    );

    return errors;
};

export const validateQualificationDetails = (formData) => {
    const errors = {};

    const qualificationErrors = {};

    formData?.qualificationDetails?.forEach(
        (qualification, index) => {
            const rowErrors = {};

            if (!qualification.division?.trim()) {
                rowErrors.division =
                    "Division is required";
            } else if (
                !/^[A-Za-z0-9\s./+-]+$/.test(
                    qualification.division
                )
            ) {
                rowErrors.division =
                    "Please enter a valid Division";
            }

            if (
                Object.keys(rowErrors).length > 0
            ) {
                qualificationErrors[index] =
                    rowErrors;
            }
        }
    );

    if (
        Object.keys(qualificationErrors).length > 0
    ) {
        errors.qualificationDetails =
            qualificationErrors;
    }


    const certificationErrors = {};

    formData?.certificationDetails?.forEach(
        (certification, index) => {
            const rowErrors = {};

            // if (
            //     !certification.certificationName?.trim()
            // ) {
            //     rowErrors.certificationName =
            //         "Certification Name is required";
            // }

            // if (
            //     !certification.institutionName?.trim()
            // ) {
            //     rowErrors.institutionName =
            //         "Institution Name is required";
            // }

            // if (
            //     !certification.certificationDateOfPassing
            // ) {
            //     rowErrors.certificationDateOfPassing =
            //         "Date of Passing is required";
            // }

            if (
                !certification.certificationPercentage
            ) {
                rowErrors.certificationPercentage =
                    "Percentage is required";
            } else if (
                Number(
                    certification.certificationPercentage
                ) < 0 ||
                Number(
                    certification.certificationPercentage
                ) > 100
            ) {
                rowErrors.certificationPercentage =
                    "Percentage must be between 0 and 100";
            }

            // if (
            //     !certification.uploadDocument
            //         ?.fileUrl &&
            //     !certification.uploadDocument
            //         ?.name
            // ) {
            //     rowErrors.uploadDocument =
            //         "Please upload a document";
            // }

            if (
                Object.keys(rowErrors).length > 0
            ) {
                certificationErrors[index] =
                    rowErrors;
            }
        }
    );

    if (
        Object.keys(certificationErrors).length > 0
    ) {
        errors.certificationDetails =
            certificationErrors;
    }

    if (!formData.preOnboardingFamilyDetails.fullName?.trim()) {
        errors.fullName = "Full Name is required";
    } else if (
        !/^[A-Za-z.\s]+$/.test(
            formData.preOnboardingFamilyDetails.fullName
        )
    ) {
        errors.fullName =
            "Full Name can contain only letters and spaces";
    }

    if (!formData.preOnboardingFamilyDetails.relationship?.trim()) {
        errors.relationship = "Relationship is required";
    } else if (
        !/^[A-Za-z\s]+$/.test(
            formData.preOnboardingFamilyDetails.relationship
        )
    ) {
        errors.relationship =
            "Relationship can contain only letters and spaces";
    }

    if (!formData.preOnboardingFamilyDetails.dateOfBirth) {
        errors.dateOfBirth = "Date of Birth is required";

    } else {
        const selectedDate = new Date(
            formData.preOnboardingFamilyDetails.dateOfBirth
        );

        const today = new Date();

        selectedDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        if (selectedDate > today) {
            errors.dateOfBirth =
                "Future date is not allowed";
        }
    }



    // if (!formData.preOnboardingFamilyDetails.dateOfBirth) {
    //     errors.dateOfBirth = "Date of Birth is required";
    // } else if (
    //     new Date(formData.preOnboardingFamilyDetails.dateOfBirth) >
    //     new Date(new Date().toDateString())
    // ) {
    //     errors.dateOfBirth =
    //         "Future date is not allowed";
    // }

    if (!formData.preOnboardingFamilyDetails.nationality?.trim()) {
        errors.nationality = "Nationality is required";
    } else if (
        !/^[A-Za-z\s]+$/.test(
            formData.preOnboardingFamilyDetails.nationality
        )
    ) {
        errors.nationality =
            "Nationality can contain only letters and spaces";
    }

    if (!formData.preOnboardingFamilyDetails.dependent?.trim()) {
        errors.dependent = "Dependent is required";
    }

    if (!formData.preOnboardingFamilyDetails.benchmarkDisability?.trim()) {
        errors.benchmarkDisability =
            "Benchmark Disability is required";
    }

    if (!formData.preOnboardingFamilyDetails.occupation?.trim()) {
        errors.occupation = "Occupation is required";
    } else if (
        !/^[A-Za-z\s.-]+$/.test(
            formData.preOnboardingFamilyDetails.occupation
        )
    ) {
        errors.occupation =
            "Occupation can contain only letters and spaces";
    }

    if (
        !formData.preOnboardingFamilyDetails.annualIncome &&
        formData.preOnboardingFamilyDetails.annualIncome !== 0
    ) {
        errors.annualIncome = "Annual Income is required";
    } else if (
        Number(formData.preOnboardingFamilyDetails.annualIncome) < 0
    ) {
        errors.annualIncome =
            "Annual Income cannot be negative";
    }

    if (!formData.preOnboardingFamilyDetails.mobileNumber?.trim()) {
        errors.mobileNumber = "Mobile Number is required";
    } else if (!/^\d{10}$/.test(formData.preOnboardingFamilyDetails.mobileNumber)) {
        errors.mobileNumber = "Enter a valid 10-digit mobile number";
    }
    if (!formData.preOnboardingGratuityNomination.nomineeName?.trim()) {
        errors.nomineeName = "Nominee Name is required";
    } else if (
        !/^[A-Za-z.\s]+$/.test(
            formData.preOnboardingGratuityNomination.nomineeName
        )
    ) {
        errors.nomineeName =
            "Nominee Name can contain only letters and spaces";
    }

    if (!formData.preOnboardingGratuityNomination.nomineeRelationship?.trim()) {
        errors.nomineeRelationship =
            "Nominee Relationship is required";
    } else if (
        !/^[A-Za-z\s]+$/.test(
            formData.preOnboardingGratuityNomination.nomineeRelationship
        )
    ) {
        errors.nomineeRelationship =
            "Relationship can contain only letters and spaces";
    }

    if (!formData.preOnboardingGratuityNomination.nomineeAge) {
        errors.nomineeAge = "Nominee Age is required";
    } else if (
        Number(formData.preOnboardingGratuityNomination.nomineeAge) < 1 ||
        Number(formData.preOnboardingGratuityNomination.nomineeAge) > 120
    ) {
        errors.nomineeAge =
            "Nominee Age must be between 1 and 120";
    }

    if (!formData.preOnboardingGratuityNomination.nomineeAddress?.trim()) {
        errors.nomineeAddress = "Nominee Address is required";
    }

    if (!formData.preOnboardingGratuityNomination.amountOfShare) {
        errors.amountOfShare = "Amount of Share is required";
    } else if (
        formData.preOnboardingGratuityNomination.amountOfShare < 1 ||
        formData.preOnboardingGratuityNomination.amountOfShare > 100
    ) {
        errors.amountOfShare = "Share percentage must be between 1 and 100";
    }

    return errors;
};




export const validateOtherDetails = (formData) => {
    const errors = {};

    if (!formData.preOnboardingOtherDetails?.markOfIdentification?.trim()) {
        errors.markOfIdentification =
            "Mark of Identification is required";
    }

    if (!formData.preOnboardingOtherDetails?.practicalTraining?.trim()) {
        errors.practicalTraining =
            "Practical Training details are required";
    }

    if (!formData.preOnboardingOtherDetails?.publications?.trim()) {
        errors.publications =
            "Publication details are required";
    }

    if (!formData.preOnboardingOtherDetails?.futureCourse?.trim()) {
        errors.futureCourse =
            "Future Course details are required";
    }

    if (!formData.preOnboardingOtherDetails?.professionalMembership?.trim()) {
        errors.professionalMembership =
            "Professional Membership details are required";
    }

    if (!formData.preOnboardingOtherDetails?.legalHistory?.trim()) {
        errors.legalHistory =
            "Legal History details are required";
    }

    if (!formData.preOnboardingOtherDetails?.otherInformation?.trim()) {
        errors.otherInformation =
            "Other Information is required";
    }

    return errors;
};


// Introduced By (References)

export const validateReferences = (formData) => {
    const errors = {};

    formData.preOnboardingReferences?.forEach(
        (reference, index) => {
            const refErrors = {};

            if (!reference.referenceName?.trim()) {
                refErrors.referenceName = "Name is required";
            } else if (
                !/^[A-Za-z ]+$/.test(
                    reference.referenceName
                )
            ) {
                refErrors.referenceName =
                    "Only alphabets are allowed";
            }

            if (!reference.referenceDesignation?.trim()) {
                refErrors.referenceDesignation =
                    "Designation is required";
            } else if (
                !/^[A-Za-z ]+$/.test(
                    reference.referenceDesignation
                )
            ) {
                refErrors.referenceDesignation =
                    "Only alphabets are allowed";
            }

            if (!reference.referenceOrganisation?.trim()) {
                refErrors.referenceOrganisation =
                    "Organisation is required";
            }

            if (!reference.referenceContact?.trim()) {
                refErrors.referenceContact =
                    "Contact Number is required";
            } else if (
                !/^[0-9]{10}$/.test(
                    reference.referenceContact
                )
            ) {
                refErrors.referenceContact =
                    "Contact Number must be 10 digits";
            }

            if (!reference.referenceEmail?.trim()) {
                refErrors.referenceEmail =
                    "Email ID is required";
            } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                    reference.referenceEmail
                )
            ) {
                refErrors.referenceEmail =
                    "Please enter a valid Email ID";
            }

            if (
                Object.keys(refErrors).length > 0
            ) {
                errors[index] = refErrors;
            }
        }
    );

    return errors;
};
